






import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";
import {bus} from "@/main";

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Custom(),
      widget: "ComplianceElementScoreOverTime",
      title: "Compliance Element Score Over Time",
      cType: "msline",
      w: 4,
      h: 2,
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
        complianceElementId: {...WParamTpl.complianceElementId(), _order: 2},
      },
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: 'Score / Time',
        yaxisname: "% of elements",
        xaxisname: "Expiry",
        numbersuffix: "%",
        yAxisMaxValue: "100",
        showLabels: "1",
        rotateLabels: "0",
        // canvasTopPadding: "10",
      },
    )
  }

  function chartDSTemplate() { // required if FC data not in {data: {}} format
    return {
      categories: [],
      dataset: [],
    }
  }

  export default defineComponent({
    props: {
      config: {type: Object, required: true},
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      async function dataplotClickCallback(label: string, val: any, data: any) {
        if (!data) {
          return
        }
        const expiry = label
        const isCompliant = data.datasetIndex
        const locationId = parseInt(props.config.params.locationId.value)
        const elementId = props.config.params.complianceElementId.value.title ?
            props.config.params.complianceElementId.value.value
            : props.config.params.complianceElementId.value
        bus.$emit("chartPopup", {
          title: "Single element score - " + await getTitle(props.config.params),
          component: drillDown,
          componentArgs: {
            locationId, elementId, expiry, isCompliant
          },
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, chartDSTemplate, configChangeCallback}
    },
  })

  async function dataFetcher(params: any): Promise<{ locationid: bigint, risklabel: string, description: string, Value: number }[]> {
    const locationId = parseInt(params.locationId.value)
    const elementId = params.complianceElementId.value.title ? params.complianceElementId.value.value : params.complianceElementId.value
    const show = 2 // 1 = days (Mon, Tue, etc), 2 = months (Jan, Feb, etc)
    return await executeQuery("idr", "compliance.elementScoreOverTime",
      {locationId, elementId, userId: 1, show},
      convert)
  }

  async function getTitle(params: any) {
    if (params.complianceElementId.value.title) {
      return "Location: " + await getLocationCaption(params.locationId) + ", Element: " + params.complianceElementId.value.title
    } else { // old parameter handling (can be removed after GA)
      const r = await executeQuery("idr", "autocompleteComplianceElementId", {id: params.complianceElementId.value})
      const elTitle = r ? r[0].title : "???"
      return "Location: " + await getLocationCaption(params.locationId) + ", Element: " + elTitle
    }
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = await getTitle(config.params)
    }
  }

  function convert(data: any[]): any {
    // [{"Value":1790,"elementID":1,"description":"Fire Safety","expirydate":"Jan","iscompliant":"0"},
    //  {"Value":120,"elementID":1,"description":"Fire Safety","expirydate":"Jan","iscompliant":"1"},...]
    const categories: { label: string }[] = []
    const valuesMap = new Map<string, Map<string, number>>()
    for (const item of data) {
      if (!(valuesMap.has(item.expirydate))) {
        categories.push({label: item.expirydate})
        valuesMap.set(item.expirydate, new Map<string, number>())
      }
      const values = valuesMap.get(item.expirydate)
      if (typeof values != "undefined") {
        values.set(item.iscompliant, item.Value)
      }
    }
    const compliantDataset: { value: string }[] = []
    const nonCompliantDataset: { value: string }[] = []
    for (const category of categories) {
      const compliantValue = (valuesMap.get(category.label) || new Map()).get("1") || 0
      const nonCompliantValue = (valuesMap.get(category.label) || new Map()).get("0") || 0
      compliantDataset.push({value: (100 * compliantValue / (compliantValue + nonCompliantValue)).toFixed(2)})
      nonCompliantDataset.push({value: (100 * nonCompliantValue / (compliantValue + nonCompliantValue)).toFixed(2)})
    }
    return {
      categories: [
        {
          category: categories,
        },
      ],
      dataset: [
        {
          seriesName: "Non Compliant",
          showValues: "0",
          color: "#DC143C",
          data: nonCompliantDataset,
        },
        {
          seriesName: "Compliant",
          showValues: "0",
          color: "#6baa01",
          data: compliantDataset,
        },
      ],
    }
  }

  const drillDown = () => ({
    component: import("@/components/widgets/compliance/ComplianceElementScoreOverTimeDrillDown.vue"),
  })
